import { useState } from "react";
import Hero from "./components/Hero";
import LiveBar from "./components/LiveBar";
import Feed from "./components/Feed";
import SideRail from "./components/SideRail";
import Columns from "./components/Columns";
import SiteFooter from "./components/SiteFooter";

const nav = [
  { href: "#feed", label: "热乎快讯" },
  { href: "#comment", label: "评论区前排" },
  { href: "#rank", label: "今日热瓜榜" },
  { href: "#columns", label: "运营分区" },
];

function TopNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200 bg-background-50/85 backdrop-blur">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-lg" />
          </span>
          <span className="text-lg font-black tracking-tight text-foreground-950">
            吃瓜<span className="num text-primary-600">91</span>
          </span>
          <span className="hidden items-center gap-1 rounded-full bg-primary-100 px-2.5 py-1 text-[11px] font-bold text-primary-700 md:inline-flex">
            <i className="ri-radar-line" /> 第一线速递站
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-semibold text-foreground-700 transition hover:bg-primary-100 hover:text-primary-700"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <span className="hidden items-center gap-1.5 rounded-full border border-background-300 bg-background-100 px-3 py-2 text-xs font-bold text-foreground-800 lg:inline-flex">
            <i className="ri-user-heart-fill text-primary-500" />
            前排在线 <span className="num text-primary-600">2173</span>
          </span>
          <a
            href="#comment"
            className="hidden whitespace-nowrap rounded-lg bg-foreground-950 px-4 py-2 text-sm font-bold text-background-50 transition hover:bg-primary-600 sm:inline-flex"
          >
            抢前排
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg border border-background-300 text-xl text-foreground-800 md:hidden"
            aria-label="菜单"
          >
            <i className={open ? "ri-close-line" : "ri-menu-2-line"} />
          </button>
        </div>
      </div>

      {open && (
        <nav className="flex flex-col gap-1 border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="whitespace-nowrap rounded-lg px-3 py-2.5 text-sm font-semibold text-foreground-800 transition hover:bg-primary-100 hover:text-primary-700"
            >
              {n.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}

export default function Home() {
  return (
    <>
      <TopNav />
      <main>
        <Hero />
        <LiveBar />
        <div className="bg-background-50">
          <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-8 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-[minmax(0,1fr)_360px] lg:items-start">
            <Feed />
            <SideRail />
          </div>
        </div>
        <Columns />
      </main>
      <SiteFooter />
    </>
  );
}